module.exports = __webpack_public_path__ + "static/media/search-grey.7a3e7e2b.svg";